import { useEffect, useState } from 'react';
import { FetchState } from 'src/reducers/fetchReducer';
import PriceHistoryList from 'src/components/ProductDetails/types/PriceHistoryList';
import PriceChartItem from 'src/components/ProductDetails/types/PriceChartItem';
import { getPriceHistory, getPriceHistoryAsync } from 'src/components/ProductDetails/api/priceHistory.api';
import { transformData } from 'src/components/ProductDetails/services/PriceHistory.service';

export type PriceHistoryListState = FetchState<PriceChartItem[]>;

type usePriceHistoryListFetchProps = {
  regionId?: string;
  sourceProductId: string;
  sourceOwnerId: string;
  matchType?: string;
  priceType?: string;
};

const initialState: PriceHistoryListState = {
  loading: false,
  error: false,
  data: null,
};

const usePriceHistoryListFetch = ({
  regionId = '-1',
  sourceProductId,
  sourceOwnerId,
  matchType = 'ALL',
  priceType = '2',
}: usePriceHistoryListFetchProps): [PriceHistoryListState] => {
  const params: PriceHistoryList.Request = {
    regionId,
    sourceProductId,
    sourceOwnerId,
    matchType,
    priceType,
  };
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState<PriceHistoryList.Response | null>(null);
  const state: PriceHistoryListState = { ...initialState, loading, error };

  useEffect(() => {
    let step = 0;
    const maxStep = 9;
    const fetchData = async () => {
      try {
        if (params) {
          setLoading(true);
          const response = await getPriceHistoryAsync(params);
          if (response?.headers?.location) {
            let sLocation = response.headers.location;
            const fetchPriceHistory = async (sLocation: string) => {
              const res = await getPriceHistory(sLocation);
              if (res.status === 200 || step === maxStep) {
                setLoading(false);
                if (step === maxStep && !res) {
                  setError(true);
                }
                setData(res.data);
              } else {
                setTimeout(() => {
                  step = step + 1;
                  fetchPriceHistory(sLocation);
                }, 9000);
              }
            };
            await fetchPriceHistory(sLocation);
          }
        }
      } catch (error) {
        setLoading(false);
        setError(true);
      }
    };

    fetchData();
  }, [regionId, sourceProductId, sourceOwnerId, matchType, priceType]);

  if (data === null) {
    return [state];
  }
  if (!data) {
    return [state];
  }
  const { ownerPrice } = data;

  return [
    {
      ...state,
      data: transformData(ownerPrice, sourceOwnerId),
    },
  ];
};

export default usePriceHistoryListFetch;
